import {
    GET_INVOICE_SETTINGS,
    UPDATE_INVOICE_SETTINGS
} from '../../index.types';


export function getInvoiceSettings(data) {
    return {
        type: GET_INVOICE_SETTINGS,
        data
    }
}

export function updateInvoiceSettings(data) {
    return {
        type: UPDATE_INVOICE_SETTINGS,
        data
    }
}
